import React, { useEffect, useRef, useState } from "react";
import { Pressable, ScrollView, StyleSheet, Text, View } from "react-native";



export default function ReportGoodNewsCarousel(props) {
  const {indicatorData, mode} = props;
  const scrollRef = useRef(null);
  const activeIndexRef = useRef(0);
  const hasInitializedScroll = useRef(false);
  const [pageWidth, setPageWidth] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loopedMessages, setLoopedMessages] = useState([]);
  const [messages, setMessages] = useState([]);
  const goodText = mode && mode === "materials" ? "Indikator penilaian pada kompetensi unggulan yang perlu dipertahankan yaitu " : "Di periode ini perilaku Ananda yang perlu dipertahankan yaitu";
  const attentionText = mode && mode === "materials" ? "Indikator penilaian pada kompetensi unggulan yang perlu perhatian yaitu" : "Di periode ini perilaku Ananda yang perlu penguatan yaitu";

  useEffect(() => {
    if (!indicatorData || indicatorData.length === 0) return;
    let messagesVar = [];
    if (indicatorData["positive"] && indicatorData["positive"].length > 0) {
      messagesVar.push({"mode": "Berita Baik", "text": `${goodText} ${indicatorData["positive"][0].name}`});
    }
    if (indicatorData["attention"] && indicatorData["attention"].length > 0) {
      messagesVar.push({"mode": "Perlu Perhatian", "text": `${attentionText} ${indicatorData["attention"][0].name}`});
    }

    setMessages(messagesVar);
    const processedMessages = [messagesVar[messagesVar.length - 1], ...messagesVar, messagesVar[0]];
    setLoopedMessages(processedMessages);
  }, [indicatorData]);

  useEffect(() => {
    if (!pageWidth) return;
    hasInitializedScroll.current = true;
    scrollRef.current?.scrollTo({ x: pageWidth * (activeIndexRef.current + 1), animated: false });
  }, [pageWidth]);

  const updateActiveIndex = (index) => {
    if (activeIndexRef.current === index) return;
    activeIndexRef.current = index;
    setActiveIndex(index);
  };

  const selectPage = (index) => {
    updateActiveIndex(index);
    scrollRef.current?.scrollTo({ x: pageWidth * (index + 1), animated: true });
  };

  const handleMomentumScrollEnd = ({ nativeEvent }) => {
    if (!pageWidth || !hasInitializedScroll.current) return;

    const pageIndex = Math.round(nativeEvent.contentOffset.x / pageWidth);
    if (pageIndex === 0) {
      updateActiveIndex(messages.length - 1);
      scrollRef.current?.scrollTo({ x: pageWidth * messages.length, animated: false });
      return;
    }
    if (pageIndex === loopedMessages.length - 1) {
      updateActiveIndex(0);
      scrollRef.current?.scrollTo({ x: pageWidth, animated: false });
      return;
    }

    updateActiveIndex(pageIndex - 1);
  };

  const handleScroll = ({ nativeEvent }) => {
    if (!pageWidth || !hasInitializedScroll.current) return;

    const pageIndex = Math.round(nativeEvent.contentOffset.x / pageWidth);
    if (pageIndex <= 0) {
      updateActiveIndex(messages.length - 1);
    } else if (pageIndex >= loopedMessages.length - 1) {
      updateActiveIndex(0);
    } else {
      updateActiveIndex(pageIndex - 1);
    }
  };

  return (
    <View style={styles.container}>
      <ScrollView
        ref={scrollRef}
        horizontal
        pagingEnabled
        showsHorizontalScrollIndicator={false}
        onLayout={({ nativeEvent }) => setPageWidth(nativeEvent.layout.width)}
        onScroll={handleScroll}
        onScrollEndDrag={handleMomentumScrollEnd}
        onMomentumScrollEnd={handleMomentumScrollEnd}
        scrollEventThrottle={16}
        style={styles.carousel}
      >
        {loopedMessages.map((message, index) => (
          <View key={`${index}-${message?.mode}`} style={[styles.page, { width: pageWidth }]}>
            <View style={styles.quoteCard}>
              <Text style={styles.quoteMark}>“</Text>
              <Text style={styles.quoteTag}>{message?.mode}</Text>
              <Text style={styles.quoteText}>{message?.text}</Text>
            </View>
          </View>
        ))}
      </ScrollView>
      <View pointerEvents="none" style={styles.underlayBar} />
      <View style={styles.pagination}>
        {messages.map((message, index) => (
          <Pressable
            key={`${index}-${message.mode}`}
            accessibilityRole="button"
            accessibilityLabel={`Berita baik ${index + 1}`}
            accessibilityState={{ selected: activeIndex === index }}
            onPress={() => selectPage(index)}
            style={[styles.dot, activeIndex === index && styles.activeDot]}
          />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { height: 164, width: "100%", alignSelf: "center" },
  carousel: { zIndex: 1 },
  page: { height: 138, paddingHorizontal: 0 },
  quoteCard: { flex: 1, paddingHorizontal: 16, paddingTop: 16, paddingBottom: 14, borderRadius: 19, backgroundColor: "#DED7FF", justifyContent: "center" },
  quoteMark: { position: "absolute", top: -8, right: 12, color: "#F4F0FF", fontFamily: "Archivo-Bold", fontSize: 62, lineHeight: 72 },
  quoteTag: { alignSelf: "flex-start", paddingHorizontal: 11, paddingVertical: 6, borderRadius: 16, color: "#FFFFFF", backgroundColor: "#5423B5", fontFamily: "Archivo-Regular", fontSize: 10 },
  quoteText: { marginTop: 12, paddingRight: 10, color: "#321A70", fontFamily: "Archivo-Regular", fontSize: 14, lineHeight: 18 },
  underlayBar: { position: "absolute", zIndex: 0, left: 18, right: 18, bottom: 20, height: 12, borderRadius: 8, backgroundColor: "#5423B5" },
  pagination: { position: "absolute", left: 0, right: 0, bottom: 0, height: 18, flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 5 },
  dot: { width: 6, height: 6, borderRadius: 3, backgroundColor: "#D5C9FA" },
  activeDot: { width: 13, height: 6, borderRadius: 4, backgroundColor: "#5423B5" },
});